import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper with-padding-top" }
const _hoisted_2 = { class: "dialog-footer" }

import { computed, ref, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getOperatorApp, upsertOperatorAppInfo } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useFormRules from '@/hooks/useFormRules'
import { TerminalChannel } from '@/types/types'
import InfoTooltip from '@/components/InfoTooltip.vue'
import FormRulesFactory from '@/common/formRules'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import OperatorTerminalConfigPC from './OperatorTerminalConfigPC.vue'

export type OperationType = 'create' | 'edit'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OperatorTerminalApp',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 条件1
  brandId: {
    type: String,
  },

  // 条件2
  operatorId: {
    type: String,
  },
  operatorName: {
    type: String,
  },
},
  setup(__props) {

const props = __props

const terminalFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['appleClientId', 'googleClientId', 'googleClientIdByIos'],
    'inputEmpty',
    'inputInvalid',
  ),
})
const { t } = useI18n()



const { getTerminnalChannelDesc, terminalHomeShowTypes } = useProtocolEnums()
const editableTabsValue = ref(TerminalChannel.TC_UNKNOWN)
const configLoading = ref(false)
const formCom = ref()
const formData: Ref<Record<string, any>> = ref({
  terminal: {},
})

const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}



const configPaymentChannelShow = ref(false)
const configPaymentChannelOperatorId = ref('0')
const configPaymentChannel = (operatorId: any) => {
  console.log('---> configPaymentChannel', operatorId)
  configPaymentChannelShow.value = true
  configPaymentChannelOperatorId.value = operatorId
}


const addConfigDialog = ref(false)
const addConfigChannel = ref(TerminalChannel.TC_UNKNOWN)

const handleAddTab = () => {
  addConfigChannel.value = TerminalChannel.TC_UNKNOWN
  addConfigDialog.value = true
}
const checkExists = (nc: TerminalChannel) => {
  return !!formData.value?.terminal?.configs.find((item) => item.channel === nc)
}

const handleaddConfigChannel = () => {
  addConfigDialog.value = false

  if (addConfigChannel.value == TerminalChannel.TC_UNKNOWN) {
    return
  }
  formData.value.terminal?.configs.push({ channel: addConfigChannel.value })
  editableTabsValue.value = addConfigChannel.value
}

const isSubmitting = ref(false)
const submit = async () => {
  try {
    // await formCom.value.validate() todo: 数组规则校验待完善
    isSubmitting.value = true
    formData.value.operatorID = props.operatorId
    await upsertOperatorAppInfo(formData.value)
    ElMessage.success(t(`Base.updateSuccess`))
  } catch (error) {
    console.log('--->submit error: ', error)
  } finally {
    isSubmitting.value = false
  }
}

const loadData = async () => {
  try {
    configLoading.value = true
    formData.value = await getOperatorApp({
      id: props.brandId,
      operatorID: props.operatorId,
      operatorName: props.operatorName,
    })
    if (formData.value?.terminal?.configs?.length > 0) {
      editableTabsValue.value = formData.value?.terminal?.configs[0].channel
    }
  } catch (error) {
    console.log('--->load error: ', error)
  } finally {
    configLoading.value = false
  }
}

loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "app-card allow-overflow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formCom",
          ref: formCom,
          rules: terminalFormRule.value,
          model: formData.value,
          "label-position": "right",
          size: "default",
          "label-width": "300px",
          style: {"max-width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: editableTabsValue.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editableTabsValue).value = $event)),
              type: "card",
              addable: "",
              class: "demo-tabs",
              onEdit: handleAddTab
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.terminal.configs, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: item.channel,
                    label: _unref(getTerminnalChannelDesc)(item.channel),
                    name: item.channel,
                    style: {"max-width":"800px"}
                  }, {
                    default: _withCtx(() => [
                      (
              item.channel == _unref(TerminalChannel).TC_APP ||
              item.channel == _unref(TerminalChannel).TC_HOME_APP
            )
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "appleClientId",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appleClientId')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.appleClientIdDesc')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.appleClientId,
                                        "onUpdate:modelValue": ($event: any) => ((item.appleClientId) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (configPaymentChannel(formData.value.terminal.operatorID)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.configPaymentChannel')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "googleClientId",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.googleClientId')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.googleClientIdDesc')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.googleClientId,
                                        "onUpdate:modelValue": ($event: any) => ((item.googleClientId) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "googleClientIdByIos",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.googleClientIdByIos')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.googleClientIdDesc')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.googleClientIdByIos,
                                        "onUpdate:modelValue": ($event: any) => ((item.googleClientIdByIos) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "appid" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.appid')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.appid,
                                        "onUpdate:modelValue": ($event: any) => ((item.appid) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "secret" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appSecret')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.appSecret')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.secret,
                                        "onUpdate:modelValue": ($event: any) => ((item.secret) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "latestVersionName" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.latestVersionName')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.latestVersionNameDesc')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.latestVersionName,
                                        "onUpdate:modelValue": ($event: any) => ((item.latestVersionName) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "latestVersionCode" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.latestVersionCode')), 1),
                                      _createVNode(InfoTooltip, {
                                        content: _ctx.$t('Operation.latestVersionCodeDesc')
                                      }, null, 8, ["content"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.latestVersionCode,
                                        "onUpdate:modelValue": ($event: any) => ((item.latestVersionCode) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "forceUpgrade" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.forceUpgrade')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        class: "enable-btn",
                                        disabled: !_ctx.$hasPermission('post'),
                                        modelValue: item.forceUpgrade,
                                        "onUpdate:modelValue": ($event: any) => ((item.forceUpgrade) = $event)
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { prop: "createEvseByScan" }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.createEvseByScan')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        class: "enable-btn",
                                        disabled: !_ctx.$hasPermission('post'),
                                        modelValue: item.createEvseByScan,
                                        "onUpdate:modelValue": ($event: any) => ((item.createEvseByScan) = $event)
                                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (item.channel == _unref(TerminalChannel).TC_WECHAT_MINI_APP)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 1,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.appid,
                                        "onUpdate:modelValue": ($event: any) => ((item.appid) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (configPaymentChannel(formData.value.terminal.operatorID)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.configPaymentChannel')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.secret",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appSecret')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: item.secret,
                                        "onUpdate:modelValue": ($event: any) => ((item.secret) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (item.channel == _unref(TerminalChannel).TC_WECHAT_SERVICE)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 2,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.appid,
                                        "onUpdate:modelValue": ($event: any) => ((item.appid) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (configPaymentChannel(formData.value.terminal.operatorID)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.configPaymentChannel')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.secret",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appSecret')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: item.secret,
                                        "onUpdate:modelValue": ($event: any) => ((item.secret) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.token",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.token')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: item.token,
                                        "onUpdate:modelValue": ($event: any) => ((item.token) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.encryptKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.encryptKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.encryptKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.encryptKey) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (item.channel == _unref(TerminalChannel).TC_ALI_MINI_APP)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 3,
                            gutter: 20
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.appid",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.appid,
                                        "onUpdate:modelValue": ($event: any) => ((item.appid) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (configPaymentChannel(formData.value.terminal.operatorID)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.configPaymentChannel')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.secret",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.mctPrivateKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: item.secret,
                                        "onUpdate:modelValue": ($event: any) => ((item.secret) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.publicKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.aliPublicKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        type: "textarea",
                                        rows: 3,
                                        modelValue: item.publicKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.publicKey) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "item.encryptKey",
                                    required: ""
                                  }, {
                                    label: _withCtx(() => [
                                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.aliEncryptKey')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElInput), {
                                        modelValue: item.encryptKey,
                                        "onUpdate:modelValue": ($event: any) => ((item.encryptKey) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "item.appname",
                                required: ""
                              }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appname')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElInput), {
                                    modelValue: item.appname,
                                    "onUpdate:modelValue": ($event: any) => ((item.appname) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "item.supportShowTypes" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.homeSupportShowTypes')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: item.supportShowTypes,
                                    "onUpdate:modelValue": ($event: any) => ((item.supportShowTypes) = $event),
                                    clearable: "",
                                    multiple: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(terminalHomeShowTypes), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "item.defaultShowTypes" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.homeDefaultShowTypes')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: item.defaultShowTypes,
                                    "onUpdate:modelValue": ($event: any) => ((item.defaultShowTypes) = $event),
                                    clearable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(terminalHomeShowTypes), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "item.switchShowTypes" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.homeSwitchShowTypes')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    modelValue: item.switchShowTypes,
                                    "onUpdate:modelValue": ($event: any) => ((item.switchShowTypes) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "privateEvseSharing" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.privateEvseSharing')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    class: "enable-btn",
                                    disabled: !_ctx.$hasPermission('post'),
                                    modelValue: item.privateEvseSharing,
                                    "onUpdate:modelValue": ($event: any) => ((item.privateEvseSharing) = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { prop: "showIncomeWallet" }, {
                                label: _withCtx(() => [
                                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.showIncomeWallet')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_switch, {
                                    class: "enable-btn",
                                    disabled: !_ctx.$hasPermission('post'),
                                    modelValue: item.showIncomeWallet,
                                    "onUpdate:modelValue": ($event: any) => ((item.showIncomeWallet) = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: !_ctx.$hasPermission('post'),
                      loading: isSubmitting.value,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Base.saveChanges')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: addConfigDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addConfigDialog).value = $event)),
      title: _unref(t)('Operation.selectAppChannel'),
      width: "50%",
      top: "25vh",
      "destroy-on-close": "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleaddConfigChannel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            modelValue: addConfigChannel.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addConfigChannel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                value: _unref(TerminalChannel).TC_APP,
                label: _unref(TerminalChannel).TC_APP,
                disabled: checkExists(_unref(TerminalChannel).TC_APP)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.terminalChannelApp')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(TerminalChannel).TC_HOME_APP,
                label: _unref(TerminalChannel).TC_HOME_APP,
                disabled: checkExists(_unref(TerminalChannel).TC_HOME_APP)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.terminalChannelHomeApp')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(TerminalChannel).TC_WECHAT_MINI_APP,
                label: _unref(TerminalChannel).TC_WECHAT_MINI_APP,
                disabled: checkExists(_unref(TerminalChannel).TC_WECHAT_MINI_APP)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.terminalChannelWechatMiniApp')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(TerminalChannel).TC_WECHAT_SERVICE,
                label: _unref(TerminalChannel).TC_WECHAT_SERVICE,
                disabled: checkExists(_unref(TerminalChannel).TC_WECHAT_SERVICE)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.terminalChannelWechatService')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(TerminalChannel).TC_ALI_MINI_APP,
                label: _unref(TerminalChannel).TC_ALI_MINI_APP,
                disabled: checkExists(_unref(TerminalChannel).TC_ALI_MINI_APP)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.terminalChannelAliMiniApp')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(OperatorTerminalConfigPC, {
      modelValue: configPaymentChannelShow.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((configPaymentChannelShow).value = $event)),
      opeartorId: configPaymentChannelOperatorId.value
    }, null, 8, ["modelValue", "opeartorId"])
  ]))
}
}

})